import { useContext, useEffect, useState } from "react";
import { apiContext } from "../../../../contexts/apiContext";
import AuthContext, { Roles } from "../../../../contexts/authContext";
import { notifyError, notifySuccess } from "../../../../components/snackbar/snackbar";
import { Option, SelectInputProps } from "../../../../components/shared/selectInput/types/selectInputProps";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import { classNameBtn } from "../../../../components/shared/button/types/buttonProps";
import { styleFormFieldHalf, stylizationVerticalAlign } from "../../../../components/shared/stylization";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import ButtonField from "../../../../components/buttonField/buttonField";
import { getExtendedUsers, getUserExtendedPermissions, saveExtendedUserPermissions } from "../../../../services/administrationService/administrationService";
import Spinner from "../../../../components/spinner/spinner";
import { categories, convertUserObjectCategoryOptionsToStrings, convertUserObjectCategoriesToOptions, gminyToOptions, powiatsToOptions, prepareUserOptions, convertTerytOptionsToStrings } from "../../../../helpers/permissionsHelper";
import PermissionsContext, { ExtendedUserPermissions } from "../../../../contexts/permissionsContext";
import { UserIdToExtendedPermissions } from "../../../../helpers/rolesToPermissions";
import { setUserPermissionsIdb } from "../../../../database/indexedDbReadWrite";
import { checkIfNewRole } from "../../../../helpers/processHelper";

const AdministrationPermissionExtendedView = (props: any) => {
    const api = useContext(apiContext);
    const { userRoles, userId, username } = useContext(AuthContext);
    const { setExtendedUserPermissions, functionsPermissions } = useContext(PermissionsContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [disableBtn, setDisableBtn] = useState<boolean>(true);
    const [disableSelects, setDisableSelects] = useState<boolean>(true);
    const [editorSelectOptions, setEditorSelectOptions] = useState<Option[]>([]);
    const [editorSelectedOption, setEditorSelectedOption] = useState<Option[]>([]);
    const [categorySelectOptions, setCategorySelectOptions] = useState<Option[]>(categories);
    const [categorySelectedOptions, setCategorySelectedOptions] = useState<Option[]>([]);
    const [powiatSelectOptions, setPowiatSelectOptions] = useState<Option[]>([]);
    const [powiatSelectedOptions, setPowiatSelectedOptions] = useState<Option[]>([]);
    const [gminaSelectOptions, setGminaSelectOptions] = useState<Option[]>([]);
    const [gminaSelectedOptions, setGminaSelectedOptions] = useState<Option[]>([]);
    const [gminaDictOptions, setGminaDictOptions] = useState<Option[]>([]);
    const [powiatDictOptions, setPowiatDictOptions] = useState<Option[]>([]);
    const [powiatDict, setPowiatDict] = useState<any[]>([]);
    const [gminaDict, setGminaDict] = useState<any[]>([]);
    const [existingPermissions, setExistingPermissions] = useState<ExtendedUserPermissions>({});
    
    // User select
    useEffect(() => {
        getExtendedUsers(api.apiUrl + api.apiVersion)
        .then((res: any) => {
            setEditorSelectOptions(prepareUserOptions(res)); 
            setLoading(false);                   
        })
        .catch(() => {
            notifyError({ message: "Próba pobrania listy edytorów zakończona niepowodzeniem" });
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeSelectUser = (opt: Option[]) => {
        var disable = opt.length < 1;       
        setEditorSelectedOption(opt);
        if (disable) {
            setCategorySelectedOptions([]);
            setPowiatSelectedOptions([]);
            setGminaSelectedOptions([]);
            setDisableSelects(true);
        }
    }

    // Teryt & category selects
    useEffect(() => {
        if (editorSelectOptions.length > 0) {
            setLoading(true);
            getUserExtendedPermissions(api.apiUrl + api.apiVersion, editorSelectedOption[0].value, true)
            .then((res: any) => {       
                var gminySorted = res.gminy.sort((a: any, b: any) => a.nazwa.localeCompare(b.nazwa, 'pl'));
                var powiatySorted = res.powiaty.sort((a: any, b: any) => a.nazwa.localeCompare(b.nazwa, 'pl'));
                
                var extPerm: ExtendedUserPermissions = {}; 
                extPerm.userGminy = [...prepareGminyOptions(gminySorted, res.userTeryts, powiatySorted)];               
                extPerm.userPowiaty = [...preparePowiatOptions(powiatySorted, res.userTeryts, res.wojewodztwa)];             
                extPerm.userObjectCategories = [...prepareUserObjectCategoriesOptions(res.userObjectCategories)];
                setExistingPermissions(extPerm);
                
                setPowiatDict(powiatySorted);
                setGminaDict(gminySorted);
                setDisableSelects(editorSelectedOption.length < 1);
                setLoading(false);
            })
            .catch(() => {
                notifyError({ message: "Próba pobrania uprawnień dodatkowych użytkownika zakończona niepowodzeniem" });
            })
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editorSelectedOption]);

    useEffect(() => {
        hidePowiatFromGminySelect(powiatSelectedOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [powiatSelectedOptions])

    const prepareUserObjectCategoriesOptions = (userObjectCategories: any[]) => {
        var selected = convertUserObjectCategoriesToOptions(userObjectCategories);
        setCategorySelectedOptions(selected);
        if (selected.length > 0) {
            var optIds = selected.map(item => item.value);
            var dict = categories.filter((item: any) => !optIds.includes(item.value));
            setCategorySelectOptions(dict);
        }
        return selected;
    }

    const preparePowiatOptions = (powiatDict: any[], userTeryts: any[], wojDict: any[]) => {
        var optionsPowiat = powiatsToOptions(powiatDict, wojDict);
        var selectedPowiat = powiatDict.filter(item => userTeryts.find(elem => elem.teryt === item.teryt));
        
        var selectedOptionsPowiat: Option[] = [];
        var selectOptionsPowiat = optionsPowiat;
        
        if (selectedPowiat.length > 0) {
            selectedOptionsPowiat = optionsPowiat.filter(item => selectedPowiat.find((elem: any) => elem.id === item.value));           
            selectOptionsPowiat = optionsPowiat.filter(item => !selectedOptionsPowiat.includes(item));
        }
        else {
            selectOptionsPowiat = optionsPowiat;
        }

        setPowiatSelectedOptions(selectedOptionsPowiat);
        setPowiatSelectOptions(selectOptionsPowiat);
        setPowiatDictOptions(optionsPowiat);

        return selectOptionsPowiat;
    }

    const prepareGminyOptions = (gminaDict: any[], userTeryts: any[], powiatDict: any[]) => {
        var optionsGmina = gminyToOptions(gminaDict, powiatDict!);
        var selectedGmina = gminaDict.filter(item => userTeryts.find(elem => elem.teryt === item.teryt));
        
        var selectedOptionsGmina: Option[] = [];
        var selectOptionsGmina = optionsGmina;
      
        if (selectedGmina.length > 0) {
            selectedOptionsGmina = optionsGmina.filter(item => selectedGmina.find((elem: any) => elem.id === item.value));           
            selectOptionsGmina = optionsGmina.filter(item => !selectedOptionsGmina.includes(item));
        }

        setGminaSelectedOptions(selectedOptionsGmina);
        setGminaSelectOptions(selectOptionsGmina);
        setGminaDictOptions(optionsGmina);

        return selectedOptionsGmina;
    }

    const onChangeSelectCategory = (opt: Option[]) => {
        if (opt.length === 0) {
            setCategorySelectOptions(categories);
            setCategorySelectedOptions([]);
        }
        else {
            var tempOpt = [...opt];
            setCategorySelectedOptions(tempOpt);
            var optIds = opt.map(item => item.value);
            var dict = categories.filter((item: any) => !optIds.includes(item.value));
            setCategorySelectOptions(dict);
        }
    }

    const onChangeSelectPowiat = (opt: Option[]) => {       
        if (opt.length === 0) {
            setPowiatSelectOptions(powiatDictOptions);
            setPowiatSelectedOptions([]);
        }
        else {
            var tempOpt = [...opt];
            setPowiatSelectedOptions(tempOpt);
            var optIds = opt.map(item => item.value);
            var options = powiatDictOptions.filter((item: any) => !optIds.includes(item.value))
            setPowiatSelectOptions(options);
        }
    }

    const onChangeSelectGmina = (opt: Option[]) => {
        if (opt.length === 0) {
            setGminaSelectOptions(gminaDictOptions);
            setGminaSelectedOptions([]);
        }
        else {
            var tempOpt = [...opt];
            setGminaSelectedOptions(tempOpt);
            var optIds = opt.map(item => item.value);
            var options = gminaDictOptions.filter(item => !optIds.includes(item.value));
            setGminaSelectOptions(options);
        }
    }

    const hidePowiatFromGminySelect = (selectedPowiat: Option[]) => {
        var powiat = powiatDict.filter(item => selectedPowiat.find(elem => elem.value === item.id));
        var powiatTeryt = powiat.map((item: any) => item.teryt);
        var newGminy = gminaDict.filter((item: any) => !powiatTeryt.includes(item.teryt.substring(0, 4)));
        var newGminyOptions = gminaDictOptions.filter((item: any) => newGminy.find((elem: any) => elem.id === item.value));
        var newGminyIds = newGminyOptions.map((item: any) => item.value);
        var newSelectedGminy = gminaSelectedOptions.filter(item => newGminyIds.includes(item.value));
        setGminaSelectOptions(newGminyOptions);
        setGminaSelectedOptions(newSelectedGminy);
    }

    const getSelectInputProps = (label: string, placeholder: string, options: Option[], onChange: Function, selectedOptions: Option[], onlySingleTag: boolean, 
        disable: boolean): SelectInputProps => {
        return {
            label: label,
            placeHolder: placeholder,
            hasInputTags: true,
            options: options,
            onlySingleTag: onlySingleTag,
            onChange: onChange,
            pristine: true,
            selectedOptions: selectedOptions,
            style: styleFormFieldHalf,
            className: "extendedPermissionsSelects",
            optionsSliceOff: true,
            disabled: disable
        }
    }

    // Save button
    useEffect(() => {
        if (editorSelectedOption.length > 0) {
            var test = checkIfModified();
            setDisableBtn(!test);
        }
        else setDisableBtn(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categorySelectedOptions, powiatSelectedOptions, gminaSelectedOptions])
    
    const handleSaveBtnClick = () => {
        setLoading(true);
        
        var assignedCategories = convertUserObjectCategoryOptionsToStrings(categorySelectedOptions);   
        var assignedTeryts = convertTerytOptionsToStrings(powiatSelectedOptions, gminaSelectedOptions, powiatDict, gminaDict);
        var editorId = editorSelectedOption[0].value!;
        
        saveExtendedUserPermissions(api.apiUrl + api.apiVersion, editorId.toString(), assignedCategories, assignedTeryts)
        .then((success: any) => {
            setLoading(false);
            if (success) {
                notifySuccess({ message: `Zapisano uprawnienia dodatkowe dla użytkownika ${editorSelectedOption[0].name}` });
                if (userId === editorId && (userRoles.find((item: string) => item === Roles.PwaEditor || item === Roles.PwaEditorExtended) || checkIfNewRole(userRoles))) {
                    UserIdToExtendedPermissions(userId, api.apiUrl + api.apiVersion)
                    .then((res: any) => {
                        setExtendedUserPermissions(res);
                        setUserPermissionsIdb({name: username, roles: userRoles, permissions: functionsPermissions, extended: res});
                    })
                }
            } else {
                notifyError({ message: "Próba zapisania uprawnień dodatkowych zakończona niepowodzeniem" });
            }
            setDisableBtn(true);
        })
        .catch(() => {
            setLoading(false);
            notifyError({ message: "Próba zapisania uprawnień dodatkowych zakończona niepowodzeniem" });
        })
    }

    const checkIfModified = () => {
        var newExtendedPermissions: ExtendedUserPermissions = {
            userGminy: gminaSelectedOptions,
            userPowiaty: powiatSelectedOptions,
            userObjectCategories: categorySelectedOptions
        }
        return JSON.stringify(existingPermissions) !== JSON.stringify(newExtendedPermissions);
    }

    const saveBtnProps: ButtonFieldProps = {
        BtnProps: {
            onClick: handleSaveBtnClick,
            style: {
                width: '180px',
                height: '45px',
            },
            className: `${classNameBtn.Small} body-txt-medium`,
            disabled: disableBtn
        },
        placeHolder: "Zapisz zmiany",
        placeHolderStyle: stylizationVerticalAlign,
    }

    return (
        <>
            {loading && <div className="tableSpinner"><Spinner /></div>} 
            <SelectInput {...getSelectInputProps(
                "Imię i nazwisko",
                "Wybierz użytkownika",
                editorSelectOptions,
                onChangeSelectUser,
                editorSelectedOption,
                true,
                false
            )} />
            <SelectInput {...getSelectInputProps(
                "Rodzaj obiektu",
                "Wybierz rodzaj obiektu",
                categorySelectOptions,
                onChangeSelectCategory,
                categorySelectedOptions,
                false, 
                disableSelects
            )} />
            <div>
                <p className="body-txt-large extendedPermissionsTerytSelectsLabel">Zakres przestrzenny</p>
                <div className="extendedPermissionsTerytSelects">
                    <SelectInput {...getSelectInputProps(
                        "Powiaty",
                        "Wybierz powiaty",
                        powiatSelectOptions,
                        onChangeSelectPowiat,
                        powiatSelectedOptions,
                        false,
                        disableSelects
                    )} />
                    <SelectInput {...getSelectInputProps(
                        "Gminy",
                        "Wybierz gminy",
                        gminaSelectOptions,
                        onChangeSelectGmina,
                        gminaSelectedOptions,
                        false,
                        disableSelects
                    )} />
                </div>
            </div>
            <div className='saveBtnWrapper'>
                <ButtonField {...saveBtnProps}/>
            </div>
        </>
    )
}

export default AdministrationPermissionExtendedView;